import React, { Fragment, useEffect, useState } from 'react';

import icons from './../../icons.svg';

const ReplenishFilter = ({ setting, updateFilter, t, cabinet }) => {
  const [currentFilter, setCurrentFilter] = useState('onlyRefilledItems');

  useEffect(() => {
    if (!setting) return;
    setCurrentFilter(setting.refillFilter);
  }, [setting]);

  return (
    <Fragment>
      <div className="replenishment__filter">
        <div
          className={`replenishment__filter-title${
            currentFilter === 'onlyRefilledItems'
              ? ' replenishment__filter-title--refilled'
              : ' replenishment__filter-title--all'
          }`}
        >
          {setting.updating === true ? (
            <svg className="replenishment__filter-update">
              <use xlinkHref={`${icons}#icon-settings`} />
            </svg>
          ) : setting.error === false ? (
            <svg>
              <use xlinkHref={`${icons}#icon-filter_list`} />
            </svg>
          ) : (
            <svg className="replenishment__filter-error">
              <use xlinkHref={`${icons}#icon-warning`} />
            </svg>
          )}

          {setting.updating === true ? (
            <span>{t('cabinet:applying_setting')}</span>
          ) : setting.error === false ? (
            <span>
              {currentFilter === 'onlyRefilledItems'
                ? t('cabinet:refilled_items')
                : currentFilter === 'planogram'
                ? t('common:planogram')
                : t('cabinet:all_items')}
            </span>
          ) : (
            <span className="replenishment__filter-error">
              {t('error:error')}
            </span>
          )}
        </div>
      </div>

      {setting.updating === false && (
        <Fragment>
          <div className="replenishment__filter-legend">
            <p>{t('cabinet:filter_instruction')}</p>
          </div>
          <div className="replenishment__options">
            <div
              className={`replenishment__options-refilled${
                currentFilter === 'onlyRefilledItems'
                  ? ' replenishment__options-refilled--active'
                  : ''
              }`}
              onClick={() => {
                updateFilter('onlyRefilledItems');
              }}
            >
              <svg>
                <use xlinkHref={`${icons}#icon-checkmark-outline`} />
              </svg>
              <span>{t('cabinet:refilled_items')}</span>
            </div>

            <div
              className={`replenishment__options-all${
                currentFilter === 'allItems'
                  ? ' replenishment__options-all--active'
                  : ''
              }`}
              onClick={() => {
                updateFilter('allItems');
              }}
            >
              <svg>
                <use xlinkHref={`${icons}#icon-checkmark-outline`} />
              </svg>
              <span>{t('cabinet:all_items')}</span>
            </div>

            {/*
            cabinet.replenishment === 'on' &&
              (cabinet.deviceSubTypeName === 'scale' ||
                cabinet.deviceSubTypeName === 'hybrid') && (
                <div
                  className={`replenishment__options-all${
                    currentFilter === 'planogram'
                      ? ' replenishment__options-all--active'
                      : ''
                  }`}
                  onClick={() => {
                    updateFilter('planogram');
                  }}
                >
                  <svg>
                    <use xlinkHref={`${icons}#icon-checkmark-outline`} />
                  </svg>
                  <span>{t('common:planogram')}</span>
                </div>
              )
                */}
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ReplenishFilter;
